import { gql } from "@apollo/client";

const GET_DIRECT_UPLOAD_URL = gql`
  query activeStorageDirectUploadUrl($filename: String!, $contentType: String!, $byteSize: Int!, $checksum: String!) {
    activeStorageDirectUploadUrl(filename: $filename, contentType: $contentType, byteSize: $byteSize, checksum: $checksum) {
      url
      headers
      blobSignedId
    }
  }
`;

export { GET_DIRECT_UPLOAD_URL };
